import React, { Component } from 'react';
import { adjustBoligagent } from '../../redux/modules/boligagents';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import { setSearchQuery } from '../../redux/modules/search';
import { Grid, Row, Col } from 'react-bootstrap';
import RangeSlider from '../../common/range-slider';
import Autosuggest from 'react-autosuggest';
import { slugify } from '../../utils/format';
import { browserHistory } from 'react-router';
import qs from 'qs';
import {
  RENT_MIN,
  RENT_MAX,
  RENT_STEP,
  RENT_DEFAULT,
  ROOMS_MIN,
  ROOMS_MAX,
  ROOMS_STEP,
  ROOMS_DEFAULT,
  SIZE_MIN,
  SIZE_MAX,
  SIZE_STEP,
  SIZE_DEFAULT
} from '../../common/defaults';
import { goal } from 'kodyl-js/tracking';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

@connect(
  ({
    search,
    cities: { list, aliases },
    auth: { user },
    boligagents: { current }
  }) => ({ aliases, user, current, search, cities: list }),
  { setSearchQuery, adjustBoligagent }
)
@i18n
class Search extends Component {
  constructor(props) {
    super(props);
    const { search = {} } = props;

    if (__CLIENT__) {
      this.unlisten = browserHistory.listenBefore(() =>
        this.setState({ extendedSearch: false })
      );
    }

    this.state = {
      inputValue: search.q || '',
      extendedSearch: search.rent || search.rooms || search.size ? true : false,
      rent: search.rent ? Number(search.rent) : RENT_DEFAULT,
      rooms: search.rooms ? Number(search.rooms) : ROOMS_DEFAULT,
      size: search.size ? Number(search.size) : SIZE_DEFAULT,
      suggestions: search.q
        ? this.filterSearch(slugify(search.q))
        : props.cities || [],
      placeHolder: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      search: {
        q,
        rent = RENT_DEFAULT,
        rooms = ROOMS_DEFAULT,
        size = SIZE_DEFAULT
      }
    } = nextProps;
    if (q) {
      this.setState({
        inputValue: q,
        rent: parseInt(rent),
        rooms: parseInt(rooms),
        size: parseInt(size)
      });
    }
  }

  componentWillUnmount() {
    if (typeof this.unlisten === 'function') {
      this.unlisten();
    }
  }

  search = event => {
    if (event) {
      event.preventDefault();
    }

    const { rent, rooms, size, inputValue } = this.state;
    const {
      adjustBoligagent,
      setSearchQuery,
      user,
      current,
      cities,
      aliases
    } = this.props;
    const searchParams = ['rent', 'rooms', 'size'];

    const searchQuery = {
      q: inputValue.trim(),
      rent: (rent !== RENT_DEFAULT && parseInt(rent)) || undefined,
      rooms: (rooms !== ROOMS_DEFAULT && parseInt(rooms)) || undefined,
      size: (size !== SIZE_DEFAULT && parseInt(size)) || undefined
    };

    const boligagentQuery = searchParams.reduce((acc, item) => {
      if (searchQuery[item] !== undefined) {
        acc[item] = searchQuery[item];
      }
      return acc;
    }, {});

    if (searchQuery.q.length < 2) {
      return this.setState({
        placeholder: this.i18n('Søgeord skal indeholde mere end to tegn')
      });
    }

    this.toggleExtendedSearch(false);
    const slug = slugify(inputValue);
    const isAlias = aliases.get(capitalizeFirstLetter(inputValue));
    const shouldBoligagentUpdate =
      isAlias || Boolean(cities.filter(item => item.slug === slug).length);

    if (shouldBoligagentUpdate) {
      adjustBoligagent({
        area: isAlias ? slugify(isAlias) : slug,
        detail: { ...boligagentQuery },
        user,
        current
      });
    }

    setSearchQuery(searchQuery);
    browserHistory.push(`/search?${qs.stringify(searchQuery)}`);

    // Scroll to results
    try {
      const element = document.querySelector('.listings-container > h4');
      const y = element.getBoundingClientRect().top + window.scrollY;
      window.scroll({ top: y - 20, behavior: 'smooth' });
    } catch (e) {
      if (__DEV__) {
        console.error(e);
      }
    }

    goal({ name: 'search', data: searchQuery });
  };

  toggleExtendedSearch(value) {
    this.setState({
      extendedSearch:
        typeof value === 'boolean' ? value : !this.state.extendedSearch
    });
  }

  getValue = (range, type) => {
    this.setState({ [type]: range });
  };

  filterSearch = value => {
    // TODO: Sort by score
    // TODO: Optimise with reduce?
    const slug = slugify(value);
    return this.props.cities
      .filter(item => item.slug.indexOf(slug) !== -1)
      .slice(0, 10)
      .map(item => ({ value: item.label }));
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.filterSearch(value) });
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  getSuggestionValue = suggestion => suggestion.value;

  renderSuggestion = suggestion => suggestion.value;

  onSuggestionSelected = (ev, { suggestionValue }) => {
    this.setState({ inputValue: suggestionValue }, () => this.search(ev));
  };

  changeValue = (event, { newValue }) => {
    if (newValue.length > 1) {
      this.setState({ placeholder: false });
    }
    this.setState({ inputValue: newValue });
  };

  render() {
    const {
      inputValue,
      extendedSearch,
      rent,
      rooms,
      size,
      suggestions,
      placeholder
    } = this.state;
    const inputProps = {
      value: inputValue,
      type: 'search',
      onChange: this.changeValue,
      placeholder: placeholder || this.i18n('Where do you want to live?')
    };

    return (
      <div className="hero-unit">
        <Grid>
          <Col
            className={`${
              this.props.narrow ? '' : 'hero-search-tall'
            } hero-search-container ${placeholder ? 'has-error' : ''}`}
            md={10}
            lg={9}
          >
            <form role="form" className="hero-search" name="searchform">
              <Row>
                <Col sm={10}>
                  <Autosuggest
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    suggestions={suggestions}
                    inputProps={inputProps}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    onSuggestionSelected={this.onSuggestionSelected}
                  />
                </Col>
                <Col sm={2}>
                  <button
                    type="submit"
                    onClick={this.search}
                    className="btn btn-warning btn-block"
                  >
                    <i className="fa fa-search" />
                    {this.i18n('Search')}
                  </button>
                </Col>
              </Row>
              <div className="more-filters-container">
                <div>
                  <button
                    type="button"
                    className="more-filters-btn btn btn-default"
                    onClick={() => this.toggleExtendedSearch()}
                    data-toggle="toggle"
                    data-target=".more-filters-form"
                  >
                    <b className="caret" />
                    {` ${this.i18n('More filters')}`}
                  </button>
                  <div
                    className="more-filters-form container"
                    style={{ display: extendedSearch ? 'block' : 'none' }}
                  >
                    <RangeSlider
                      anchorLeft
                      labelTop
                      min={RENT_MIN}
                      max={RENT_MAX}
                      headline={this.i18n('Rent')}
                      label={this.i18n('Maximum rent per month')}
                      step={RENT_STEP}
                      value={rent}
                      onSlide={this.getValue}
                      measurement={this.i18n('DKK')}
                      parentState="rent"
                    />
                    <RangeSlider
                      labelTop
                      min={ROOMS_MIN}
                      max={ROOMS_MAX}
                      headline={this.i18n('Rooms')}
                      label={this.i18n('Minimum number of rooms')}
                      step={ROOMS_STEP}
                      value={rooms}
                      onSlide={this.getValue}
                      measurement={this.i18n('rooms')}
                      parentState="rooms"
                    />
                    <RangeSlider
                      labelTop
                      min={SIZE_MIN}
                      max={SIZE_MAX}
                      headline={this.i18n('Size')}
                      label={this.i18n('Minimum size')}
                      step={SIZE_STEP}
                      value={size}
                      onSlide={this.getValue}
                      measurement={this.i18n('m2')}
                      parentState="size"
                    />
                  </div>
                </div>
              </div>
            </form>
          </Col>
        </Grid>
      </div>
    );
  }
}

export default Search;
